/* eslint-disable object-shorthand */
import React from "react";
import sanitizeHtml from "sanitize-html";
import { useTheme } from "styled-components";

function Footnote({ color, description }) {
  const theme = useTheme();

  return (
    <div
      style={{
        display: "grid",
        placeItems: "center",
        width: "100%",
      }}
    >
      <div title={description && sanitizeHtml(description)}>
        <span
          style={{
            fontSize: "30px",
            position: "relative",
            top: "5px",
            color: theme.text.text,
          }}
        >
          Footnote
        </span>
        <span
          style={{
            color: color?.[theme.name],
            fontSize: "30px",
          }}
        >
          1
        </span>
      </div>
    </div>
  );
}

export default Footnote;
